import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VueScrollactive from 'vue-scrollactive';
import VueScrollReveal from 'vue-scroll-reveal';

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(VueScrollactive);
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal',
  duration: 700,
  delay: 100,
  scale: 1,
  distance: '20px',
  mobile: true,
  origin: 'left'
});

const routes = [
  {
    path: '/es',
    name: 'ES',
    component: App
  },
  {
    path: '/',
    name: 'EN',
    component: App
  } 
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
